import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import SeoListPageShell from 'ui/shared/seo/SeoListPageShell';

const SignedAuthorizations = dynamic(() => import('ui/pages/SignedAuthorizations'), { ssr: false });

const Page: NextPage = () => {
  return (
    <SeoListPageShell pathname="/signed-authorizations" title="EIP-7702 Authorizations">
      <SignedAuthorizations hideTitle/>
    </SeoListPageShell>
  );
};

export default Page;

export { base as getServerSideProps } from 'nextjs/getServerSideProps';
